<template>
  <div class="cinema-list" v-track="{ act: 'ready', data: { id: 357 } }">
    <my-header class="header" :showHome="false">
      <div slot="title">影院</div>
      <div slot="left" class="city" @click="toCity" v-track="{ act: 'click', data: { id: 361 } }">
        <span>{{ (selected.cityId ? selected.name : locate.name) | resolveName }}</span>
        <img src="../../../../image/cinema/xia.png" width="6px" height="3px" />
      </div>
      <div slot="right">
        <div class="toCinemaSearch" @click="toCinemaSearch" v-track="{ act: 'click', data: { id: 362 } }">
          <img src="../../../../image/cinema/search.png" width="18px" height="18px" alt />
        </div>
      </div>
    </my-header>
    <!-- <amap
      :cinemas="activeCinemas"
      v-if="isShowMap"
    />-->
    <!-- <div class="map-toggle-btn">
      <img src="../../../../image/cinema/iconLockerOpen@2x.png" alt="">
      <img src="../../../../image/cinema/iconLocker@2x.png" alt="">
    </div>-->
    <div class="cinema-list-tag">
      <div class="cinema-list-tag-name">
        <label @click="showAreaFilter" :class="{ selected: isShowAreaFilter }">
          {{ selectedDistrict }}
          <img src="../../../../image/cinema/shang.png" width="6px" height="3px" v-show="isShowAreaFilter" />
          <img src="../../../../image/cinema/xia.png" width="6px" height="3px" v-show="!isShowAreaFilter" />
        </label>
        <label @click="showCinemaType" :class="{ selected: isShowCinemaType }">
          {{ selectedCinemaType }}
          <img src="../../../../image/cinema/shang.png" width="6px" height="3px" v-show="isShowCinemaType" />
          <img src="../../../../image/cinema/xia.png" width="6px" height="3px" v-show="!isShowCinemaType" />
        </label>
        <label @click="showFilter" :class="{ selected: isShowFilter }">
          {{ selectedFilter }}
          <img src="../../../../image/cinema/shang.png" width="6px" height="3px" v-show="isShowFilter" />
          <img src="../../../../image/cinema/xia.png" width="6px" height="3px" v-show="!isShowFilter" />
        </label>
      </div>
    </div>
    <div class="cinema-layer"></div>
    <my-banner :banner="cinemaBanner"></my-banner>
    <div class="cinema-list-wrap" :class="{ 'fix-cinema-list': isShowMap }">
      <ul class="cinema-list">
        <li v-for="(cinema, index) in list" :key="cinema.name" class="cinema-list-item">
          <router-link
            :to="selectedCinemaType == 'APP订票' ? `/cinema/${cinema.cinemaId}/film` : `/cinema/${cinema.cinemaId}`"
            class="cinema-item-wrap"
            v-track="{ act: index < 10 ? 'click' : '', data: { id: 363, p: [cinema.cinemaId] } }"
          >
            <div class="cinema-info-lf cinema-info">
              <span class="cinema-name">{{ cinema.name }}</span>
              <img v-show="cinema.isVisited == 1 && selectedCinemaType == 'APP订票'" class="isVisted" src="../../../../image/card/isVisted.png" alt="去过" />
              <span class="ticketType" v-if="selectedCinemaType == '前台兑换' && cinema.ticketTypes && cinema.ticketTypes.length > 0">
                <span v-for="(ticketType, index) in cinema.ticketTypes" :key="index">
                  <strong v-if="index != 0">|</strong>
                  {{ ticketType.name }}
                </span>
              </span>
              <span class="cinema-address">{{ cinema.address }}</span>
            </div>
            <div class="cinema-info-rt cinema-info">
              <div :class="{ hidePrice: cinema.lowPrice <= 0 || selectedCinemaType == '前台兑换' }">
                <decimal-price :price="cinema.lowPrice" myclz="cinema-lowPrice" :unit="true"></decimal-price>
                <span class="upon">起</span>
              </div>
              <span class="cinema-gpsAddress">
                <img v-show="selectedCinemaType == '前台兑换'" src="../../../../image/card/position.png" alt="距离" />
                <strong>{{ cinema.distance }}</strong>
              </span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <mt-popup position="top" pop-transition="popup-fade" v-model="isShowAreaFilter" class="area-box filter-box">
      <div class="filter-wrap">
        <ul class="district-list">
          <li
            v-for="district in cinemaDistrict"
            :key="district"
            data="district"
            v-track="{ act: 'click', data: { id: 358 } }"
            @click="changeDistrict(district)"
          >
            <div :class="{ selected: selectedDistrict == district }">{{ district }}</div>
          </li>
        </ul>
      </div>
    </mt-popup>
    <mt-popup position="top" pop-transition="popup-fade" v-model="isShowCinemaType" class="area-box filter-box">
      <div class="filter-wrap">
        <ul class="filter-list">
          <li @click="changeCinemaType(1)" :class="{ selected: 'APP订票' == selectedCinemaType }">
            <img src="../../../../image/cinema/iconTick.png" width="13px" height="9px" v-if="'APP订票' == selectedCinemaType" alt />
            <span class="placehold" v-else style="width:13px;"></span>
            <span class="filter-text">APP订票</span>
          </li>
          <li @click="changeCinemaType(0)" :class="{ selected: '前台兑换' == selectedCinemaType }">
            <img src="../../../../image/cinema/iconTick.png" width="13px" height="9px" v-if="'前台兑换' == selectedCinemaType" alt />
            <span class="placehold" v-else style="width:13px;"></span>
            <span class="filter-text">前台兑换</span>
          </li>
        </ul>
      </div>
    </mt-popup>
    <mt-popup position="top" pop-transition="popup-fade" v-model="isShowFilter" class="area-box filter-box">
      <div class="filter-wrap">
        <ul class="filter-list">
          <li @click="changeFilter(1)" :class="{ selected: '最近去过' == selectedFilter }">
            <img src="../../../../image/cinema/iconTick.png" width="13px" height="9px" v-if="'最近去过' == selectedFilter" alt />
            <span class="placehold" v-else style="width:13px;"></span>
            <span class="filter-text">最近去过</span>
          </li>
          <li @click="changeFilter(0)" :class="{ selected: '离我最近' == selectedFilter }" v-track="{ act: 'click', data: { id: 359 } }">
            <img src="../../../../image/cinema/iconTick.png" width="13px" height="9px" v-if="'离我最近' == selectedFilter" alt />
            <span class="placehold" v-else style="width:13px;"></span>
            <span class="filter-text">离我最近</span>
          </li>
        </ul>
      </div>
    </mt-popup>
  </div>
</template>
<script>
import { myIndicator } from '../../../components/my-indicator'
import Icon from '../../../components/icon'
import myHeader from '../../../components/header'
import decimalPrice from '../../../components/decimal-price'
import { getDistanceBetween } from '../../../util/function'
import { os } from '../../../util/platform.js'
import { Popup } from 'mint-ui'
import _ from 'underscore'
import { mapState, mapActions, mapGetters } from 'vuex'
import CITYCONSTANT from '../../../constant/city'
import cookie from '../../../lib/cookie'
import amap from '../../../components/amap.vue'
import Banner from './banner'
export default {
  data() {
    return {
      list: [],
      isShowAreaFilter: false,
      isShowFilter: false,
      isShowCinemaType: false,
      cinemaDistrict: ['全城'],
      selectedDistrict: '全城',
      selectedCinemaType: 'APP订票',
      selectedFilter: '最近去过',
      // selected: {cityId: 0, name: ''},
      isShowMap: false,
      activeCinemas: [],
    }
  },
  computed: {
    ...mapState({
      locate: state => state.city.locate,
      currentPosition: state => `${state.city.gps.latitude}:${state.city.gps.longitude}`,
      cinemaList(state) {
        let ticketFlag = this.selectedCinemaType == 'APP订票' ? 1 : 2
        const list = _.filter(state.cinema.cinemaList, v => {
          return (ticketFlag == 1 && v.seatFlag == 1) || (ticketFlag == 2 && v.eTicketFlag == 1)
        })
        return list
      },
      cinemaBanner: state => state.cinema.cinemaBanner,
    }),
    ...mapGetters(['cityGetSelectedCity']),
    selected() {
      return this.cityGetSelectedCity
    },
    resolveList() {
      return this.cinemaList.map(item => {
        const distance = getDistanceBetween(item.gpsAddress, this.currentPosition)
        return {
          cinemaId: item.cinemaId,
          name: item.name,
          address: item.address,
          lowPrice: item.lowPrice,
          isVisited: item.isVisited,
          // eTicketFlag: item.eTicketFlag,
          seatFlag: item.seatFlag,
          ticketTypes: item.ticketTypes,
          district: item.district,
          distance: distance != '距离未知' ? `${distance}km` : '距离未知',
        }
      })
    },
  },
  mounted() {
    window.scrollTo(0, 0)
    this.queryCinemaList(this.selected.cityId)
    this.getCinemaBanner(this.selected.cityId)
  },
  methods: {
    ...mapActions(['getLocate', 'getCinemaList', 'getGPSPosition', 'getCinemaBanner']),
    handleScroll() {
      this.$nextTick(() => {
        const header = document.querySelector('header')
        const tag = document.querySelector('.cinema-list-tag')
        const amap = document.querySelector('.map-container')
        const item = document.querySelector('.cinema-list-item')
        const bar = document.querySelector('.nav-bar')
        const topHeight = header.clientHeight + tag.clientHeight + amap.clientHeight
        const doms = document.querySelectorAll('.cinema-list-item')
        let arr = []
        _.map(doms, (v, i) => {
          // console.log(v.getBoundingClientRect().top )
          if (v.getBoundingClientRect().top >= topHeight - item.clientHeight && v.getBoundingClientRect().top < window.outerHeight - bar.clientHeight) {
            arr.push(this.list[i])
          }
        })
        this.activeCinemas = arr
      })
    },
    queryCinemaList(id) {
      // console.log('111')
      const vm = this
      let ticketFlag = this.selectedCinemaType == 'APP订票' ? 1 : 2
      // console.log(ticketFlag);
      this.getCinemaList({
        cityId: id,
        ticketFlag: ticketFlag, //0：返回全部，1：返回含有订座票的影院，2：返回含有电子票的影院
      })
        .then(res => {})
        .finally(myIndicator())
    },
    // resolveList(list) {
    //   const vm = this
    //   return list.map((item) => {
    //     return {
    //       latitude: item.latitude,
    //       longitude: item.longitude,
    //       cinemaId: item.cinemaId,
    //       name: item.name,
    //       address: item.address,
    //       lowPrice: item.lowPrice,
    //       isVisited: item.isVisited,
    //       district: item.district,
    //       gpsAddress: item.gpsAddress,
    //       distance: getDistanceBetween(item.gpsAddress, vm.currentPosition),
    //     }
    //   })
    // },
    showAreaFilter() {
      this.isShowAreaFilter = !this.isShowAreaFilter
      if (this.isShowFilter || this.isShowCinemaType) {
        this.isShowFilter = false
        this.isShowCinemaType = false
      }
    },
    showFilter() {
      this.isShowFilter = !this.isShowFilter
      if (this.isShowAreaFilter || this.isShowCinemaType) {
        this.isShowAreaFilter = false
        this.isShowCinemaType = false
      }
    },
    showCinemaType() {
      this.isShowCinemaType = !this.isShowCinemaType
      if (this.isShowFilter || this.isShowAreaFilter) {
        this.isShowFilter = false
        this.isShowAreaFilter = false
      }
    },
    changeDistrict(district) {
      this.selectedDistrict = district
      this.showAreaFilter()
    },
    changeFilter(type) {
      let text
      if (type == 1) {
        text = '最近去过'
      } else {
        text = '离我最近'
      }
      this.selectedFilter = text
      this.showFilter()
    },
    changeCinemaType(type) {
      let text
      if (type == 1) {
        text = 'APP订票'
      } else {
        text = '前台兑换'
      }
      this.selectedCinemaType = text
      this.showCinemaType()
      this.queryCinemaList(this.selected.cityId)
    },
    toFilmList() {
      this.$router.push(`/films/nowPlaying`)
    },
    toCity() {
      this.$router.push(`/city`)
    },
    toCinemaSearch() {
      this.$router.push(`/cinemas/search`)
    },
    filterByVisit(val) {
      // console.log(val)
      let isVisited
      if (val == '最近去过') {
        isVisited = 1
      } else {
        isVisited = 0
      }
      this.list = _.sortBy(this.list, item => {
        return parseFloat(item.distance)
      })
      if (isVisited) {
        let trueList = []
        let falseList = []
        _.chain(this.list)
          .groupBy(cinema => {
            return cinema.isVisited == 1
          })
          .map((list, selected) => {
            if (selected === 'true') {
              trueList = [...list]
            } else {
              falseList = [...list]
            }
          })
        this.list = [...trueList, ...falseList]
      }
    },
  },
  watch: {
    currentPosition(n, o) {
      // if (n != o) {
      //   let list = [...this.cinemaList]
      //   this.cinemaList = this.resolveList(list)
      // }
    },
    resolveList(val) {
      let resDistricts = []
      _.chain(val)
        .groupBy(cinema => {
          return cinema.district.name
        })
        .map((list, name) => {
          resDistricts.push(name)
        })
      this.cinemaDistrict = ['全城', ...resDistricts]
      this.list = val
      this.filterByVisit(this.selectedFilter)
      // this.handleScroll()
    },
    selectedDistrict(val) {
      let seletctedList = []
      _.chain(this.resolveList)
        .groupBy(cinema => {
          if (val != '全城') {
            return cinema.district.name == val
          } else {
            return true
          }
        })
        .map((list, selected) => {
          if (selected === 'true') {
            this.list = [...list]
          }
        })
      this.filterByVisit(this.selectedFilter)
    },
    selectedFilter(val) {
      this.filterByVisit(val)
    },
  },
  components: {
    Icon,
    [Popup.name]: Popup,
    'decimal-price': decimalPrice,
    'my-header': myHeader,
    amap,
    'my-banner': Banner,
  },
  filters: {
    resolveName(val) {
      if (val.length > 3) {
        return val.substr(0, 3) + '...'
      }
      return val
    },
  },
}
</script>
<style lang="less">
@import '../../../../stylesheet/variable.less';
@battleshipGrey: rgb(121, 125, 130);
@paleGrey: rgb(210, 214, 220);
@textBlack: rgb(25, 26, 27);
@reddish: rgb(192, 49, 49);
@butterscotch: rgb(255, 178, 50);
.cinema-list {
  .header {
    z-index: 2000;
    img {
      vertical-align: middle;
    }
    .cinema-list-title {
      color: #191a1b;
      width: 100%;
      height: 100%;
      padding: 7px 0;
    }
    .cinema-header {
      width: 142px;
      height: 27px;
      font-size: 14px;
      word-spacing: -5px;
      display: inline-block;
      span {
        width: 67px;
        display: inline-block;
        line-height: 25px;
      }
      .title-selected {
        background-color: @reddish;
        color: #fff;
        border: 0.5px solid @reddish;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        z-index: 2;
      }
      .title-unselected {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        border: 0.5px solid rgb(210, 214, 220);
        z-index: 1;
      }
    }
    .city {
      display: flex;
      align-items: center;
      i {
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: top;
      }
      span {
        display: inline-block;
        font-size: 13px;
        max-width: 58px;
        height: 16px;
        line-height: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 5px;
        color: @textBlack;
      }
    }
  }
  .mint-popup {
    z-index: 1901 !important;
    transition: none;
  }
  .v-modal {
    background: rgba(0, 0, 0, 0.6);
    z-index: 1900 !important;
  }
  .filter-box {
    top: 94px;
  }
  .filter-wrap {
    width: 100vw;
  }
  .district-list {
    list-style: none;
    padding: 10px 0 0 0;
    margin: 0 0 0 10px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    flex-wrap: wrap;
    li {
      font-size: 12px;
      display: inline-block;
      width: calc(~'(100vw - 50px)/4');
      padding-bottom: 15px;
      padding-right: 10px;
      height: 30px;
      flex-shrink: 1;
      div {
        position: relative;
        color: @battleshipGrey;
        border-radius: 3px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        &::after {
          .setBorderLine(rgba(210, 214, 220, 0.5));
        }
      }
      .selected {
        color: @orange;
        &::after {
          .setBorderLine(@orange);
        }
      }
    }
  }
  .filter-list {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      height: 44px;
      width: 100vw;
      padding: 0 15px;
      position: relative;
      color: @battleshipGrey;
      .filter-text {
        margin-left: 10px;
        font-size: 13px;
        letter-spacing: -0.2px;
        line-height: 44px;
      }
      .placehold {
        display: inline-block;
        width: 13px;
      }
      &::after {
        .setBottomLine();
      }
    }
    .selected {
      color: @orange;
    }
  }
  .cinema-layer {
    padding-top: 94px;
  }
  .cinema-list-wrap {
    padding-bottom: 49px;
    z-index: 100;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    li {
      // height: 45px;
      position: relative;
      background-color: #fff;
      padding: 15px;
      &::after {
        .setBottomLine();
      }
      .cinema-item-wrap {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .cinema-info-lf {
          width: calc(~'100% - 65px');
          text-align: left;
          padding-right: 15px;
          float: left;
          span {
            display: block;
            max-width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            float: left;
          }
          .cinema-name {
            color: @textBlack;
            font-size: 15px;
            float: left;
          }
          .isVisted {
            width: 32px;
            height: 16.5px;
            margin-bottom: -6px;
            margin-left: 4px;
          }
          .ticketType {
            line-height: 15px;
            width: 240px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 15px;
            margin-top: 5px;
            font-size: 12px;
            letter-spacing: -0.1px;
            color: rgb(121, 125, 130);
            margin-right: 5px;
            p {
              float: left;
            }
          }
          .cinema-address {
            color: @battleshipGrey;
            font-size: 12px;
            margin-top: 5px;
          }
        }
        .cinema-info-rt {
          width: 70px;
          text-align: center;
          float: right;
          margin-right: -5px;
          .cinema-gpsAddress {
            display: block;
            font-size: 11px;
            color: @battleshipGrey;
            margin-top: 5px;
            img {
              display: block;
              width: 13px;
              height: 17.5px;
              margin: 0 auto;
              margin-top: -30px;
            }
            strong {
              font-weight: normal;
              display: block;
              margin-top: 5px;
            }
          }
          .upon {
            color: @orange;
            font-size: 10px;
          }
          .hidePrice {
            visibility: hidden;
          }
        }
      }
    }
  }
  .cinema-list-tag {
    position: fixed;
    height: 50px;
    width: 100%;
    top: 44px;
    right: 0;
    text-align: center;
    background-color: #fff;
    z-index: 2000;
    &::after {
      .setBottomLine();
    }
    .cinema-list-tag-line {
      position: absolute;
      bottom: -4px;
      width: 100%;
      z-index: 10;
      div {
        float: left;
        width: 50%;
      }
      label {
        display: inline-block;
        width: 50px;
      }
      label.selected {
        border: 1px solid @reddish;
        background-color: @reddish;
        border-radius: 2px;
      }
    }
    .cinema-list-tag-name {
      position: relative;
      label {
        float: left;
        width: 33.3%;
        line-height: 49px;
        font-size: 14px;
        color: @textBlack;
        letter-spacing: -0.2px;
        i {
          margin-left: 6px;
        }
      }
      .selected {
        color: @orange;
      }
      img {
        vertical-align: middle;
        padding-left: 2px;
      }
    }
  }
  .fix-cinema-list {
    position: absolute;
    bottom: 49px;
    padding: 0;
    height: calc(~'100vh - 343px');
    overflow-y: auto;
  }
}
</style>
